import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import cookies from "js-cookie";
import httpService from "../../../services/httpServices/httpServices";
import helperNumber from "../../../helpers/numbers";
import helperSpinner from "../../../helpers/spinner";
import helpersTime from "../../../helpers/time";
import TypeGroupSitePublisher from "./TypeGroupSitePublisher";
import actionCookie from "../../../helpers/action-cookie";
import Pagination from "../../partials/content/Pagination";

function GroupPublisher() {
  cookies.set(
    actionCookie.PREVIOUS_PAGE,
    actionCookie.PREVIOUS_PAGE_VALUE_ALL_PUBLISHERS
  );

  const [groupUserSitePublisher, setGroupUserSitePublisher] = useState([]);
  const [typeAdvertiseSelect, setTypeAdvertiseSelect] = useState("banner");
  const [linkPageAddGroup, setLinkPageAddGroup] = useState(false);
  const [showSelectTagMannerAddGroup, setShowSelectTagMannerAddGroup] =
    useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [countItemPerPage, setCountItemPerPage] = useState(10);
  const [countPage, setCountPage] = useState(1);
  const [nameCategorySearchFilter, setNameCategorySearchFilter] = useState();

  useEffect(() => {
    getGroupUserSitePublisher();
  }, []);

  useEffect(() => {
    getGroupUserSitePublisher();
  }, [currentPage, countItemPerPage, nameCategorySearchFilter]);

  const getGroupUserSitePublisher = async () => {
    const searchFilterQuery = getSearchFilterQuery();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const groupUserSitePublisher = await sendRequestGetGroupUserSitePublisher(
      searchFilterQuery
    );
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!groupUserSitePublisher) {
      return false;
    }
    setGroupUserSitePublisher(
      groupUserSitePublisher.category_user_site_publishers
    );
    setCountPage(groupUserSitePublisher.count_page);
  };

  const getSearchFilterQuery = () => {
    let searchFilterQuery = "";
    if (nameCategorySearchFilter) {
      searchFilterQuery = `${searchFilterQuery}&name=${nameCategorySearchFilter}`;
    }

    return searchFilterQuery;
  };

  const generateTagGroupUserSitePublisher = (groupUserSitePublisher) => {
    return groupUserSitePublisher.map((group, index) => {
      return (
        <tr key={index}>
          <td>{helperNumber.toPersianNum(index + 1)}</td>
          <td>{helperNumber.toPersianNum(group.id)}</td>
          <td>{group.name}</td>
          <td className="number-finance">
            <span>
              {helperNumber.toPersianNum(
                helpersTime.convertGregorianToJalali(group.start_date)
              )}
            </span>
            <span className="pl-2">۰۰:۰۰</span>
          </td>
          <td className="number-finance">
            <span>
              {helperNumber.toPersianNum(
                helpersTime.convertGregorianToJalali(group.end_date)
              )}
            </span>
            <span className="pl-2">۲۳:۵۹</span>
          </td>
          <td className="number-finance">
            {helperNumber.toPersianNum(
              group.created_at.split(" ")[1] +
                " " +
                helpersTime.convertGregorianToJalali(
                  group.created_at.split(" ")[0]
                )
            )}
          </td>
          <td>
            <div>
              <span className="pl-2">
                <Link
                  to={`/publishers/edit-group/${group.type}/${group.id}`}
                  className="btn btn-success  "
                >
                  <i className="fa fa-edit"></i>
                </Link>
              </span>
            </div>
          </td>
        </tr>
      );
    });
  };

  const paginationItemOnClickHandler = async (e) => {
    if (!e.target.attributes[1]) {
      return;
    }

    setCurrentPage(e.target.attributes[1].value);
  };

  const generatePagination = () => {
    return (
      <div className="py-2 d-flex flex-column flex-md-row  align-items-md-center  ">
        <Pagination
          countPage={countPage}
          currentPage={currentPage}
          paginationItemOnClickHandler={paginationItemOnClickHandler}
        />
      </div>
    );
  };

  const sendRequestDeleteGroupUserSitePublisher = async (groupID) => {
    const headersRequest = getHeaderForRequest();
    try {
      await httpService.deleteRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/category-user-site-publishers/" +
          groupID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return true;
  };

  const sendRequestGetGroupUserSitePublisher = async (searchFilterQuery) => {
    const headersRequest = getHeaderForRequest();
    let groupUserSitePublisher;
    try {
      groupUserSitePublisher = await httpService.getRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/category-user-site-publishers-pagination?page=${currentPage}&number=${countItemPerPage}${searchFilterQuery}`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return groupUserSitePublisher.data.data;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const generateUserDoseNotHaveCategoryTag = () => {
    return (
      <div className="d-flex flex-column flex-md-row">
        <div className="text-center text-md-right">
          <img
            className="img-fluid"
            src="/assets/img/do-not-have-category-site-publisher.svg"
          />
        </div>
        <div className="d-flex flex-column justify-content-center pr-0 pt-3  pr-md-3 pt-md-0">
          <p>شما هیچ گروه نمایش دهنده بنری ندارد :(</p>
          <p>برای شروع کار یک گروه نمایش دهنده بسازید.</p>
          {showButtonGroup()}
        </div>
      </div>
    );
  };

  const showButtonGroup = () => {
    return (
      <div className="d-flex flex-column flex-lg-row ">
        <div className="pb-2 pb-lg-2">
          <div
            className="btn btn-success"
            onClick={() => {
              setShowSelectTagMannerAddGroup(true);
            }}
          >
            <span className="pl-2">
              <i className="fa fa-plus"></i>
            </span>
            <span>
              <span>اضافه کردن گروه جدید</span>
            </span>
          </div>
        </div>
        {showSelectTagMannerAddGroup && (
          <>
            <div className="pb-2 pb-lg-0 pr-lg-2">
              <select
                className="form-control"
                onChange={(e) => {
                  const link = e.target.value;
                  if (!link) {
                    setLinkPageAddGroup(false);
                    return;
                  }
                  setLinkPageAddGroup(link);
                }}
              >
                <option value="">روش ساخت گروه را انتخاب کنید</option>
                <option value="/publishers/add-group/banner">دستی</option>
                <option value="/publishers/add-group-automate/banner">
                  خودکار
                </option>
              </select>
            </div>

            {linkPageAddGroup && (
              <div className="pb-2 pr-lg-2">
                <Link to={linkPageAddGroup} className="btn btn-success">
                  افزودن
                </Link>
              </div>
            )}
          </>
        )}
      </div>
    );
  };

  const generateTagCampaigns = () => {
    return (
      <>
        {showButtonGroup()}
        <div className="container-fluid">
          <div className="row border border-1 rounded py-2">
            <div className="col-12 col-md-4">
              <div>
                <label>جستجو در نام گروه نمایش دهنده</label>
              </div>
              <div>
                <input
                  className="form-control"
                  id="site"
                  type="text"
                  placeholder="نام گروه نمایش دهنده را در اینجا وارد کنید "
                  onKeyUp={(e) => setNameCategorySearchFilter(e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="table-responsive pt-3">
          <table className="table table-hilite tbl-td-white-space mb-0">
            <thead>
              <tr>
                <td>#</td>
                <td>شماره گروه</td>
                <td>نام گروه</td>
                <td>تاریخ شروع</td>
                <td>تاریخ پایان</td>
                <td>تاریخ درج</td>
                <td>عملیات</td>
              </tr>
            </thead>
            <tbody>
              {generateTagGroupUserSitePublisher(groupUserSitePublisher)}
            </tbody>
          </table>
        </div>
        {countPage > 1 ? generatePagination() : <></>}
      </>
    );
  };

  return (
    <>
      <div
        className="tab-pane fade border border-3 p-2 rounded"
        id="group-publisher"
        role="tabpanel"
        aria-labelledby="group-publisher-tab"
      >
        {groupUserSitePublisher.length == 0 && nameCategorySearchFilter == null
          ? generateUserDoseNotHaveCategoryTag()
          : generateTagCampaigns()}
      </div>
    </>
  );
}

export default GroupPublisher;
